import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from "@mui/icons-material/Search";
import {InputBase} from "@mui/material";
import {useStyles} from "./AppbarSearchField.css";

export default function AppbarSearchField({onTextSubmitted, ...props}) {
    const classes = useStyles();

    return (
        <div className={classes.search}>
            <div className={classes.searchIcon}>
                <SearchIcon/>
            </div>
            <div>
                <InputBase
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                    }}
                    inputProps={{'aria-label': 'search'}}
                    onChange={event => onTextSubmitted(event.target.value)}
                    {...props}
                >
                </InputBase>
            </div>
            <div className={classes.closeIcon}>
                <CloseIcon onClick={() => {
                    onTextSubmitted('')
                }}/>
            </div>
        </div>

    );
}